import React from "react"

import useSignInViaReturningHash from "hooks/useSignInViaReturningHash"
import Wayfinder from "shared/wayfinder"

const ReturningUser = () => {
  const { data, loading } = useSignInViaReturningHash()

  if (!data || loading) {
    return null
  }

  return <Wayfinder />
}

export default ReturningUser
